export default __webpack_public_path__ + "static/media/quokka.5f00f45c.jpg";